export default __webpack_public_path__ + "static/media/promotion-bottom-mobile.5d680791.png";